import React from 'react';
import ClassSelect from './SearchConditions/ClassSelect';
import LevelSelect from './SearchConditions/LevelSelect';
import TagSelect from './SearchConditions/TagSelect';

let SearchConditions = ({currentFilters, setFilters}) => {


    let showSection = (e) => {
      e.target.classList.toggle("active");
     var content = e.target.nextElementSibling;
     if (content.style.display === "block") {
       content.style.display = "none";
     } else {
       content.style.display = "block";
     }
   };


  return (
    <div className="search-conditions">
      <ClassSelect currentFilters={currentFilters} setFilters={setFilters}/>
      <LevelSelect currentFilters={currentFilters} setFilters={setFilters}/>
      <button type="button" className="collapsible" onClick={showSection}>Filter by Tags</button>
      <TagSelect currentFilters={currentFilters} setFilters={setFilters}/>
    </div>
  )
};
export default SearchConditions;
